import { render, staticRenderFns } from "./ProfilEmail.vue?vue&type=template&id=08fcdcb2"
import script from "./ProfilEmail.vue?vue&type=script&lang=js"
export * from "./ProfilEmail.vue?vue&type=script&lang=js"
import style0 from "./ProfilEmail.vue?vue&type=style&index=0&id=08fcdcb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports